var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52861 5.52876C3.78896 5.26841 4.21107 5.26841 4.47141 5.52876L8.00001 9.05735L11.5286 5.52876C11.789 5.26841 12.2111 5.26841 12.4714 5.52876C12.7318 5.78911 12.7318 6.21122 12.4714 6.47157L8.47141 10.4716C8.21107 10.7319 7.78896 10.7319 7.52861 10.4716L3.52861 6.47157C3.26826 6.21122 3.26826 5.78911 3.52861 5.52876Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-down.3445c498de9008d829c9ecd2a8c67dbb.svg";